/* @flow */

import React, { Component } from 'react';
import ViewBlockItem from './ViewBlockItem';
import EditoBlockItem from './EditBlockItem';

type BlockMode = 'view' | 'edit';

type Props = {
  mode: CatalogRenderingMode,
  templates: Array<EditorialBlockTemplate>,
  block: EditorialBlock,
  blocks: List<EditorialBlock>,
  onUpdate: (block: EditorialBlock) => void,
  onOrderChanged: (block: EditorialBlock, order: number) => void,
  onDelete: (block: EditorialBlock) => void,
  locked?: boolean,
};

type State = {
  displayMode: BlockMode,
};

const mapBlockToMode = (block: EditorialBlock) =>
  (block.isNew ? 'edit' : 'view');

class BlockItem extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      displayMode: mapBlockToMode(props.block),
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.block !== this.props.block) {
      this.setState({
        displayMode: mapBlockToMode(nextProps.block),
      });
    }
  }

  onSwitchMode = () =>
    this.setState((prevState, props) => {
      return {
        displayMode: prevState.displayMode === 'view' ? 'edit' : 'view',
      };
    });

  onSaveBlock = (block: EditorialBlock) => {
    this.props.onUpdate({
      ...block,
      isNew: undefined,
    });
    this.onSwitchMode();
  };

  render() {
    const {
      mode,
      templates,
      block,
      blocks,
      onOrderChanged,
      onDelete,
      locked,
    } = this.props;
    const { displayMode } = this.state;

    const changeOrder = (order: number) => onOrderChanged(block, order);
    const remove = () => onDelete(block);

    switch (displayMode) {
      case 'view':
        return (
          <ViewBlockItem
            templates={templates}
            block={block}
            blocks={blocks}
            onEdit={this.onSwitchMode}
            onOrderChanged={changeOrder}
            onDelete={remove}
            locked={locked}
          />
        );
      case 'edit':
        return (
          <EditoBlockItem
            mode={mode}
            block={block}
            onSave={this.onSaveBlock}
            onCancel={this.onSwitchMode}
          />
        );
      default:
        console.warn(`Unknown block mode ${displayMode}. Cannot render`);
        return null;
    }
  }
}

export default BlockItem;



// WEBPACK FOOTER //
// ./src/modules/edito/components/BlockItem.js